import React from "react";
import styled from "styled-components";
import {getAvatar} from "@models/user";
import {getLogo} from "@models/agency";
import {LazyLoadImage} from 'react-lazy-load-image-component';

// size => 80,72,64,56,48
function Avatar({src, size, className, type = 'user', alt = '', lazyLoad = true}) {


    if (typeof size == "undefined") {
        size = 72;
    }

    if (typeof src == "undefined" || src == '') {
        src = getAvatar('');
    }

    const handleOnError = (e) => {
        let path = getAvatar('');

        if (type === 'agency') {
            path = getLogo('');
        }

        e.target.src = path;
    };

    if (lazyLoad) {
        return (
            <Container>
                <LazyLoadImage
                    src={src}
                    effect="blur"
                    wrapperClassName="avatars-lazy"
                    className={"bg-gray100 img-circle avatar-" + size + (className ? ' ' + className : '')}
                    onError={handleOnError}
                    alt={alt + ' ۲نبش'}
                />
            </Container>
        )
    } else {
        return (
            <img src={src} className={"bg-gray100 img-circle avatar-" + size + (className ? ' ' + className : '')} onError={handleOnError} alt={alt + ' ۲نبش'}/>
        )
    }
}

export default React.memo(Avatar);

// styles

const Container = styled.div`

    img {
        background-color: ${props => props.theme.gray100};
    }
`;